export default __webpack_public_path__ + "static/media/Popup_Cross.d55d3b0f.svg";